// native
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

// service
import { ItemsDisplayService } from '../../../core/services/items-display.service';
import { UrlService } from '../../../core/services/url.service';

// model
import { IDisplayItem } from '../../../models';

@Component({
  selector: 'scs-item-panel',
  templateUrl: './item-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemPanelComponent implements OnInit {

  item: IDisplayItem;
  isLibraryItemWithPdf: boolean;
  isGlobalItemWithDoi: boolean;

  constructor(
    private itemsDisplayService: ItemsDisplayService,
    public urlService: UrlService
  ) { }

  ngOnInit(): void {
    this.item = this.itemsDisplayService.getPanelItem();

    this.isLibraryItemWithPdf = this.item?.collection_id && (this.item?.primary_file_type === 'pdf');
    this.isGlobalItemWithDoi = !this.item?.collection_id && !!this.item?.ext_ids?.doi;
  }

  onCloseClick() {
    this.itemsDisplayService.itemPanelVisible$.next(false);
  }

  onViewArticleClick() {
    if (this.isGlobalItemWithDoi) {
      this.urlService.viewArticleByDoi(this.item);
      return;
    }

    this.urlService.viewArticle(this.item);
  }
}
